import React, { useEffect } from "react";

import { useHistory } from "react-router";
import { ThemeProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";

import { Header } from "../../components/Header";
import { NetworkProvider } from "../../contexts/NetworkContext";
import { MatchDatesStatusProvider } from "../../contexts/MatchDatesStatusContext";
import { PageTablePaginationProvider } from "../../components/PageTablePagination/context";

import { MUITheme } from "../../constants/theme";
import useAuth from "../../routes/login/AuthContext";
import { OAUTH_ERROR_URL } from "../../routes/oauthError/OAuthErrorContainer";
import { FAILURE_URL } from "../../routes/failure/FailureContainer";
import { buildOAuthErrorSearch, clearOAuthError, getOAuthError } from "../../helpers/oauthError";
import { getAppConfig } from "../../AppConfig";
import { SnackbarProvider } from "../../components/EnhancedSnackbar/context";
import { HeaderSpacing } from "../../components/HeaderSpacing";
import { Box } from "../../UI/Box";
import { Nav } from "../../components/Nav";
import { DrawerHeader } from "../../components/Nav/styles";
import { HeaderProvider } from "../../components/Header/context";
import { NetworksProvider } from "../../contexts/NetworksProvider";

export const PageLayout: React.FC = (props) => {
  const history = useHistory();
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    const oauthError = getOAuthError();

    if (!oauthError) {
      return;
    }

    // One-shot: clear so navigating away doesn't loop back.
    clearOAuthError();

    // Active Directory (client SSO) shows the actual error on the dedicated page.
    // Other providers (e.g. Google) keep the original "Network Access Pending" page.
    const isActiveDirectory = getAppConfig().provider !== "Google";

    if (isActiveDirectory) {
      if (history.location.pathname !== OAUTH_ERROR_URL) {
        history.replace({
          pathname: OAUTH_ERROR_URL,
          search: `?${buildOAuthErrorSearch(oauthError)}`,
        });
      }
    } else if (history.location.pathname !== FAILURE_URL) {
      history.replace(FAILURE_URL);
    }
  }, [history]);

  return (
    <NetworksProvider>
      <NetworkProvider>
        <ThemeProvider theme={MUITheme}>
          <MUIThemeProvider theme={MUITheme}>
            <PageTablePaginationProvider>
              <CssBaseline />
              <SnackbarProvider>
                <MatchDatesStatusProvider>
                  <HeaderProvider>
                    <Box display="flex" height="100%">
                      {isLoggedIn() && (
                        <>
                          <Header />
                          <Nav />
                        </>
                      )}
                      <Box sx={{ flexGrow: 1 }}>
                        {isLoggedIn() && (
                          <>
                            <HeaderSpacing />
                            <DrawerHeader />
                          </>
                        )}
                        {props.children}
                      </Box>
                    </Box>
                  </HeaderProvider>
                </MatchDatesStatusProvider>
              </SnackbarProvider>
            </PageTablePaginationProvider>
          </MUIThemeProvider>
        </ThemeProvider>
      </NetworkProvider>
    </NetworksProvider>
  );
};
